import React, { useState } from 'react';
import Header from '../components/Header';

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const MEZZI = [
  {
    id: 'aereo',
    emoji: '✈️',
    nome: 'Aereo',
    tagline: 'Vola al miglior prezzo',
    descrizione: 'Confronta voli diretti e con scalo tra centinaia di compagnie aeree, low-cost e tradizionali. Filtra per durata, numero di scali, fascia oraria e includi o escludi il bagaglio nel prezzo.',
    cosa_confronti: [
      'Voli diretti vs. con scalo',
      'Compagnie low-cost (Ryanair, EasyJet, Wizz) e tradizionali',
      'Prezzi con bagaglio a mano, stiva o entrambi',
      'Flessibilità cancellazione e cambio data',
      'Aeroporti alternativi nella stessa città',
    ],
    colore: '#1a56db',
  },
  {
    id: 'treno',
    emoji: '🚄',
    nome: 'Treno',
    tagline: 'Veloce, comodo, sostenibile',
    descrizione: 'Cerca e confronta treni ad alta velocità, intercity e regionali su tutto il territorio europeo. Confronta Frecciarossa, Italo, Eurostar e i principali operatori internazionali in un\'unica ricerca.',
    cosa_confronti: [
      'Alta velocità (Frecciarossa, Italo, TGV, Eurostar)',
      'Intercity e treni notturni',
      'Prima, seconda classe e offerte speciali',
      'Abbonamenti settimanali e mensili',
      'Coincidenze e tempi di percorrenza',
    ],
    colore: '#0e9f6e',
  },
  {
    id: 'bus',
    emoji: '🚌',
    nome: 'Mezzi Pubblici',
    tagline: 'Muoviti in città come un locale',
    descrizione: 'Pianifica gli spostamenti urbani e interurbani con metro, tram, autobus e treni regionali. Confronta biglietti singoli, giornalieri, settimanali e abbonamenti per ogni città di destinazione.',
    cosa_confronti: [
      'Metro, tram, autobus e treni suburbani',
      'Biglietti singoli vs. abbonamenti a tempo',
      'Card turistiche (es. Roma Pass, Paris Visite)',
      'Orari, frequenze e mappe delle linee',
      'Accessibilità e fermate principali',
    ],
    colore: '#7e3af2',
  },
  {
    id: 'bici',
    emoji: '🚲',
    nome: 'Bicicletta',
    tagline: 'Scopri la destinazione in libertà',
    descrizione: 'Esplora la destinazione su due ruote. Confronta servizi di bike sharing, noleggio tradizionale ed e-bike. Ideale per città ciclofile o per integrare altri mezzi di trasporto.',
    cosa_confronti: [
      'Bike sharing (abbonamento orario, giornaliero)',
      'Noleggio tradizionale e e-bike',
      'Percorsi ciclabili e sicurezza delle strade',
      'Possibilità di portare la bici su treni/traghetti',
      'Copertura assicurativa inclusa',
    ],
    colore: '#f59e0b',
  },
  {
    id: 'auto',
    emoji: '🚗',
    nome: 'Auto',
    tagline: 'Massima libertà di movimento',
    descrizione: 'Confronta noleggi auto, carsharing e opzioni di guida autonoma. Calcola pedaggi, parcheggi e carburante per avere il costo reale del viaggio su strada, senza sorprese.',
    cosa_confronti: [
      'Noleggio auto (Hertz, Europcar, Sixt e aggregatori)',
      'Carsharing e auto su strada',
      'Pedaggi autostradali per paese e percorso',
      'Costo carburante stimato per il tragitto',
      'Parcheggi in centro, aeroporti e stazioni',
    ],
    colore: '#6b7280',
  },
];

const STEPS = [
  {
    num: '1',
    titolo: 'Scegli la destinazione',
    testo: 'Inserisci da dove parti e dove vuoi arrivare. Puoi aggiungere più destinazioni per creare un itinerario multi-tappa.',
    colore: C.trasporto,
  },
  {
    num: '2',
    titolo: 'Confronta tutti i mezzi',
    testo: 'OCTA mostra in parallelo aerei, treni, bus, bici e auto. Ordina per prezzo, durata o sostenibilità e trova la soluzione giusta per te.',
    colore: C.alloggio,
  },
  {
    num: '3',
    titolo: 'Combina e salva',
    testo: 'Puoi scegliere mezzi diversi per tratte diverse (volo + treno + bici in città) e salvare tutto nella tua esperienza OCTA.',
    colore: C.servizi,
  },
];

export default function Trasporto() {
  const [mezzoAttivo, setMezzoAttivo] = useState('aereo');

  const mezzo = MEZZI.find(m => m.id === mezzoAttivo);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.88; }
        .octa-hamburger { display: none; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 24px !important; }
          .octa-hero-t { padding: 52px 32px 60px !important; }
          .octa-hero-t h1 { font-size: 40px !important; }
          .octa-section { padding: 52px 32px !important; }
          .octa-compare-grid { flex-wrap: wrap !important; }
          .octa-footer { padding: 24px 32px !important; }
        }
        @media (max-width: 640px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .octa-hero-t { padding: 48px 20px 56px !important; }
          .octa-hero-t h1 { font-size: 36px !important; }
          .octa-section { padding: 48px 20px !important; }
          .octa-steps { flex-direction: column !important; }
          .octa-mezzo-tabs { gap: 6px !important; }
          .octa-mezzo-tabs button { padding: 8px 12px !important; font-size: 13px !important; }
          .octa-compare-grid { flex-direction: column !important; }
          .octa-footer { padding: 24px 16px !important; flex-direction: column !important; align-items: flex-start !important; }
        }
      `}</style>

      <Header bg={C.trasporto} />

      {/* HERO */}
      <section className="octa-hero-t" style={{ backgroundColor: C.trasporto, padding: '64px 60px 72px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '8px 20px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', marginBottom: '28px' }}>
            <img src="/images/trasporto_icona.png" alt="Trasporto" style={{ height: '18px' }} onError={e => { e.target.style.display='none'; }} />
            <span style={{ fontSize: '13px', fontWeight: 700, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Segmento Trasporto</span>
          </div>
          <h1 style={{ fontSize: '52px', fontWeight: 900, color: C.white, lineHeight: 1.1, marginBottom: '20px' }}>
            Confronta tutti i mezzi.<br />
            <span style={{ color: C.white }}>Scegli il tuo viaggio.</span>
          </h1>
          <p style={{ fontSize: '18px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.7, maxWidth: '640px', margin: '0 auto 40px' }}>
            Aereo, treno, bus, bici o auto: OCTA confronta tutti i mezzi di trasporto in un'unica ricerca modulare, così puoi scegliere la combinazione giusta per ogni tratta del tuo viaggio.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/bacheca" style={{ padding: '14px 28px', borderRadius: '50px', backgroundColor: C.white, color: C.trasporto, fontSize: '15px', fontWeight: 700 }}>
              Esplora la bacheca
            </a>
            <a href="/crea" style={{ padding: '14px 28px', borderRadius: '50px', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.8)', fontSize: '15px', fontWeight: 600 }}>
              Racconta un viaggio →
            </a>
          </div>
        </div>
      </section>

      {/* BADGE COMING SOON */}
      <div style={{ backgroundColor: '#fffbeb', borderBottom: '1px solid #fde68a', padding: '14px 40px', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', color: '#92400e', fontWeight: 600 }}>
          🚀 La ricerca comparativa in tempo reale è in arrivo — per ora puoi condividere i tuoi viaggi passati e scoprire quelli degli altri.
        </p>
      </div>

      {/* SEZIONE: CONFRONTA I MEZZI */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.white }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, color: C.trasporto, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>I mezzi di trasporto</p>
            <h2 style={{ fontSize: '36px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Ogni mezzo, confrontato nei dettagli</h2>
            <p style={{ fontSize: '16px', color: C.textLight, maxWidth: '560px', margin: '0 auto' }}>
              Seleziona un mezzo per scoprire cosa puoi confrontare e come OCTA ti aiuta a trovare l'opzione migliore.
            </p>
          </div>

          {/* TAB MEZZI */}
          <div className="octa-mezzo-tabs" style={{ display: 'flex', gap: '8px', marginBottom: '32px', flexWrap: 'wrap', justifyContent: 'center' }}>
            {MEZZI.map(m => (
              <button
                key={m.id}
                onClick={() => setMezzoAttivo(m.id)}
                style={{
                  padding: '10px 20px', borderRadius: '50px', border: `2px solid ${mezzoAttivo === m.id ? C.trasporto : C.border}`,
                  backgroundColor: mezzoAttivo === m.id ? C.trasporto : C.white,
                  color: mezzoAttivo === m.id ? C.white : C.textLight,
                  fontSize: '14px', fontWeight: 700, transition: 'all 0.15s',
                  display: 'flex', alignItems: 'center', gap: '7px',
                }}
              >
                <span style={{ fontSize: '18px' }}>{m.emoji}</span> {m.nome}
              </button>
            ))}
          </div>

          {/* CARD MEZZO ATTIVO */}
          <div style={{ backgroundColor: C.light, borderRadius: '20px', border: `1px solid ${C.border}`, overflow: 'hidden' }}>
            <div style={{ padding: '32px 40px', borderBottom: `1px solid ${C.border}`, background: `linear-gradient(135deg, ${C.dark} 0%, #1a2a45 100%)` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
                <span style={{ fontSize: '40px' }}>{mezzo.emoji}</span>
                <div>
                  <p style={{ fontSize: '11px', fontWeight: 700, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>{mezzo.tagline}</p>
                  <h3 style={{ fontSize: '28px', fontWeight: 900, color: C.white }}>{mezzo.nome}</h3>
                </div>
              </div>
              <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.65)', lineHeight: 1.65, maxWidth: '680px' }}>{mezzo.descrizione}</p>
            </div>
            <div style={{ padding: '32px 40px' }}>
              <p style={{ fontSize: '13px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>Cosa puoi confrontare</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
                {mezzo.cosa_confronti.map((voce, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '14px 16px', backgroundColor: C.white, borderRadius: '10px', border: `1px solid ${C.border}` }}>
                    <span style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: C.trasporto, color: C.white, fontSize: '12px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>✓</span>
                    <span style={{ fontSize: '14px', color: C.text, lineHeight: 1.45 }}>{voce}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEZIONE: RICERCA MODULARE */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.light }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '56px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, color: C.trasporto, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Ricerca modulare</p>
            <h2 style={{ fontSize: '36px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Combina i mezzi per ogni tratta</h2>
            <p style={{ fontSize: '16px', color: C.textLight, maxWidth: '560px', margin: '0 auto' }}>
              Non tutti i viaggi sono uguali. OCTA ti permette di scegliere mezzi diversi per tratte diverse e costruire il percorso su misura.
            </p>
          </div>

          {/* ESEMPIO ITINERARIO COMPARATIVO */}
          <div className="octa-compare-grid" style={{ display: 'flex', gap: '16px', alignItems: 'stretch' }}>
            {[
              { tratta: 'Milano → Barcellona', opzioni: [
                { mezzo: '✈️ Volo diretto', dettaglio: 'Ryanair · 2h 05m', prezzo: '€ 89', evidenza: true },
                { mezzo: '🚄 Treno + Bus', dettaglio: 'TGV + ALSA · 9h 30m', prezzo: '€ 74', evidenza: false },
                { mezzo: '🚗 Auto propria', dettaglio: 'Casello + carburante', prezzo: '≈ €120', evidenza: false },
              ]},
              { tratta: 'Barcellona centro', opzioni: [
                { mezzo: '🚇 Metro + Bus', dettaglio: 'T-Casual · tutto il giorno', prezzo: '€ 11', evidenza: true },
                { mezzo: '🚲 Bicing e-bike', dettaglio: 'Bike sharing · giornaliero', prezzo: '€ 7', evidenza: false },
                { mezzo: '🚗 Auto a noleggio', dettaglio: 'ZTL + parcheggio', prezzo: '≈ €45', evidenza: false },
              ]},
            ].map((blocco, bi) => (
              <div key={bi} style={{ flex: 1, backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, overflow: 'hidden' }}>
                <div style={{ padding: '16px 20px', backgroundColor: C.dark, borderBottom: `3px solid ${C.trasporto}` }}>
                  <p style={{ fontSize: '13px', fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Tratta</p>
                  <p style={{ fontSize: '16px', fontWeight: 900, color: C.white }}>{blocco.tratta}</p>
                </div>
                <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {blocco.opzioni.map((op, oi) => (
                    <div key={oi} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderRadius: '10px', border: `1px solid ${op.evidenza ? C.trasporto : C.border}`, backgroundColor: op.evidenza ? 'rgba(235,28,36,0.04)' : C.white }}>
                      <div>
                        <p style={{ fontSize: '14px', fontWeight: op.evidenza ? 700 : 500, color: C.text }}>{op.mezzo}</p>
                        <p style={{ fontSize: '12px', color: C.textLight, marginTop: '2px' }}>{op.dettaglio}</p>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <p style={{ fontSize: '15px', fontWeight: 900, color: op.evidenza ? C.trasporto : C.text }}>{op.prezzo}</p>
                        {op.evidenza && <p style={{ fontSize: '10px', fontWeight: 700, color: C.trasporto, textTransform: 'uppercase', letterSpacing: '0.06em' }}>miglior prezzo</p>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p style={{ fontSize: '13px', color: C.textLight, textAlign: 'center', marginTop: '20px' }}>
            * Prezzi e orari di esempio a scopo illustrativo. La ricerca in tempo reale è in sviluppo.
          </p>
        </div>
      </section>

      {/* SEZIONE: COME FUNZIONA */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.trasporto }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Come funziona</p>
          <h2 style={{ fontSize: '36px', fontWeight: 900, color: C.white, marginBottom: '48px' }}>Tre passi per trovare il trasporto ideale</h2>
          <div className="octa-steps" style={{ display: 'flex', gap: '24px', alignItems: 'flex-start' }}>
            {STEPS.map((step, i) => (
              <div key={i} style={{ flex: 1, textAlign: 'center' }}>
                <div style={{ width: '52px', height: '52px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.2)', color: C.white, fontSize: '22px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>{step.num}</div>
                {i < STEPS.length - 1 && (
                  <div style={{ display: 'none' }} />
                )}
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: C.white, marginBottom: '10px' }}>{step.titolo}</h3>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.65 }}>{step.testo}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEZIONE: CTA — CONDIVIDI UN VIAGGIO */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.white, textAlign: 'center' }}>
        <div style={{ maxWidth: '620px', margin: '0 auto' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '16px', backgroundColor: 'rgba(235,28,36,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: '30px' }}>✈️</div>
          <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Hai già viaggiato?<br />Condividi come ti sei spostato.</h2>
          <p style={{ fontSize: '16px', color: C.textLight, lineHeight: 1.7, marginBottom: '36px' }}>
            Racconta come hai raggiunto la tua destinazione — con quale mezzo, a che prezzo e com'è andata. Le tue esperienze aiutano gli altri viaggiatori a scegliere meglio.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/crea" style={{ padding: '14px 32px', borderRadius: '50px', backgroundColor: C.trasporto, color: C.white, fontSize: '15px', fontWeight: 700 }}>
              + Racconta un viaggio
            </a>
            <a href="/bacheca" style={{ padding: '14px 32px', borderRadius: '50px', border: `2px solid ${C.border}`, color: C.textLight, fontSize: '15px', fontWeight: 600 }}>
              Esplora la bacheca
            </a>
          </div>
        </div>
      </section>

      {/* ALTRI SEGMENTI */}
      <section className="octa-section" style={{ padding: '48px 60px', backgroundColor: C.light, borderTop: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <p style={{ fontSize: '13px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px', textAlign: 'center' }}>Esplora gli altri segmenti</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { label: 'Alloggio', color: C.alloggio, href: '/alloggio' },
              { label: 'Attività', color: C.attivita, href: '/attivita' },
              { label: 'Servizi', color: C.servizi, href: '/servizi' },
            ].map(seg => (
              <a key={seg.label} href={seg.href} style={{ padding: '10px 24px', borderRadius: '50px', border: `2px solid ${seg.color}`, color: seg.color, fontSize: '14px', fontWeight: 700, backgroundColor: C.white }}>
                {seg.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="octa-footer" style={{ padding: '32px 60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.trasporto, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}
